import { render, staticRenderFns } from "./MoneyboxNotEmptyModal.vue?vue&type=template&id=15b8fc50&scoped=true&"
import script from "./MoneyboxNotEmptyModal.vue?vue&type=script&lang=js&"
export * from "./MoneyboxNotEmptyModal.vue?vue&type=script&lang=js&"
import style0 from "./MoneyboxNotEmptyModal.vue?vue&type=style&index=0&id=15b8fc50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b8fc50",
  null
  
)

export default component.exports